import React, { useEffect } from "react";
import { Toaster } from "sonner";
import { Navbar } from "../../components/website/Navbar";
import { Hero } from "../../components/website/Hero";
import { Showcase } from "../../components/website/Showcase";
import { Programs } from "../../components/website/Programs";
import { WhyUs } from "../../components/website/WhyUs";
import { Memberships } from "../../components/website/Memberships";
import { Gallery } from "../../components/website/Gallery";
import { Testimonials } from "../../components/website/Testimonials";
import { EnquiryForm } from "../../components/website/EnquiryForm";
import { Footer } from "../../components/website/Footer";

export default function Home() {
  useEffect(() => {
    document.title = "SVT Golden Fitness | Best Gym in Bangalore";
  }, []);

  return (
    <div className="bg-black font-body text-white min-h-screen" data-testid="website-home">
      <Toaster position="top-center" richColors theme="dark" />
      <Navbar />
      <main>
        <Hero />
        <Showcase />
        <Programs />
        <WhyUs />
        <Memberships />
        <Gallery />
        <Testimonials />
        <EnquiryForm />
      </main>
      <Footer />
    </div>
  );
}
